module.exports = __webpack_public_path__ + "static/img/平面人像拍摄.5299f8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10010/平面人像拍摄.png
// module id = KOkc
// module chunks = 1